/** Temporarily disable family account types and subscription management in Family Management. */
export const ENABLE_FAMILY_ACCOUNT_TYPES = false;

/** Temporarily disable institution subscription configuration when creating institutions. */
export const ENABLE_INSTITUTION_SUBSCRIPTION = false;

/** Extended campaign audiences: trip type, family, and stop targeting (UI + payload shape). */
export const ENABLE_EXTENDED_CAMPAIGN_AUDIENCES = true;
